import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';
import { SMART_INSIGHTS_HELP_ARTICLE } from 'lumen/utils/constants/smart-insights';

interface GeneralSmartInsightsFooterSmartInsightsSignature {
  Args: {};
}

const FooterSmartInsights: TOC<GeneralSmartInsightsFooterSmartInsightsSignature> =
  <template>
    <div
      class="bg-elevation-surface border-neutral-default flex w-full flex-row items-center gap-100 border-t px-500 py-300"
    >
      <GeneralNavigationIntercomHelpLink
        @articleLink={{SMART_INSIGHTS_HELP_ARTICLE}}
        @iconName="book"
        @iconPlacement="before"
        @isStandaloneLink={{true}}
        @linkText={{t "smart_insights.smart_insights_explained"}}
        @textSize="small"
        @type="text-and-icon"
      />
    </div>
  </template>;

export default FooterSmartInsights;
